import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SignInfo } from '../../domain-models/SignInfo';

import { SignInfoService } from '../../services/sign-info/sign-info.service';
import { SignMessRequestsService } from '../../services/signMessRequests/sign-mess-requests.service';
import { AuthService } from '../../services/auth/auth.service';
//import { SelectItem } from 'primeng/primeng';
import { MessageSignLogsService } from 'services/messageSignLogs/message-sign-logs.service';
import { MessageSignLogs } from 'domain-models/MessageSignLogs';
import { StatusNamesService } from 'services/statusNames/status-names.service';
import { StatusNames } from 'domain-models/StatusNames';
import { SelectItem } from 'libraries/SelectItem';
import { Helper } from 'libraries/Helper';

@Component({
	selector: 'app-dmslog',
	moduleId: module.id,
	templateUrl: './dmslog.component.html',
	styleUrls: ['./dmslog.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class DmslogComponent implements OnInit {
	users: string[];

	loading: Boolean = false;
	yearFilter: string;
	messageSignLogs: Array<MessageSignLogs>;

	signList = new Array<SelectItem>();
	cityList = new Array<SelectItem>();
	statusList = new Array<SelectItem>();

	constructor(private messageSignLogsService: MessageSignLogsService) {}

	ngOnInit() {
		this.loading = true;
		this.signList.push({ label: 'No filter', value: null });
		this.cityList.push({ label: 'No filter', value: null });
		this.statusList.push({ label: 'No filter', value: null });

		this.messageSignLogsService.getAll().subscribe((result) => {
			if (result.length > 0) {
				let now = new Date();
				this.messageSignLogs = result;
				this.messageSignLogs.forEach((log) => {
					log.DateInsertedFormated = Helper.FormateDate(new Date(log.DateInserted));
					log.DateSent = Helper.FormateDateOnly(new Date(log.DateSent));
					log.MessageDuration = log.MessageDuration;

					if (log.MessageDuration && Helper.DurationToMs(log.MessageDuration) > 0)
						log.MessageExpiration = Helper.FormateDate(
							Helper.TimeFromTimeAndDuration(log.MessageDuration, log.DateInserted)
						);
					else log.MessageExpiration = 'N/A';
				});

				this.populateFilters();
				this.loading = false;
			} else {
				this.loading = false;
			}
		});
	}

	populateFilters() {
		const statuses = Array.from(new Set(this.messageSignLogs.map((m) => m.StatusNameDisplay)));
		const signs = Array.from(new Set(this.messageSignLogs.map((m) => m.SignName)));
		const cities = Array.from(new Set(this.messageSignLogs.map((m) => m.City)));

		signs.forEach((sign) => {
			let label = sign;
			let value = sign;
			this.signList.push({ label, value });
		});

		cities.forEach((city) => {
			let label = city;
			let value = city;
			this.cityList.push({ label, value });
		});

		statuses.forEach((status) => {
			let label = status;
			let value = status;
			this.statusList.push({ label, value });
		});
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/dmslog/dmslog.component.ts